import { Redirect, Route, RouteProps } from "react-router";
import { useAppSelector } from "../app/hooks";
import { appPath } from "./AppRoute";

export const InputRoute = (props: RouteProps) => {

  const branchId = useAppSelector(
    (state) => state.inputAnswer.selectedBranch?.id
  );

  const isCommonQR = useAppSelector(
    (state): boolean =>
      !!state.inputAnswer.session.cxHttpRes?.data?.cxAppSession.shopqr?.token
        ?.isCommon
  );

  // Handle when page refeshed and selected branch ID is null
  if (!branchId && isCommonQR) {
    return <Redirect to={appPath.shopqr.inputBranch} />
  }

  return <Route {...props} />
}
